import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SelfAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-4180">
      <div className="max-w-4xl mx-auto" data-id="element-4181">
        {/* Back button */}
        <div className="mb-8" data-id="element-4182">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-4183">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-4184" />
            <span className="font-medium" data-id="element-4185">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-4186">
          <div className="flex justify-between items-center mb-2" data-id="element-4187">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-4188">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-4189">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4190">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-4191"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-4192">
          {currentStep === 1 && <div data-id="element-4193">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-4194">
                Let's start with the basics
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-4195">
                We'll ask you a few questions to understand your current setup.
              </p>
              <div className="space-y-6 mb-8" data-id="element-4196">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-4197">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-4198">
                    Do you use a password manager?
                  </h3>
                  <div className="space-y-3" data-id="element-4199">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4200">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4201" />
                      <span className="font-medium" data-id="element-4202">
                        Yes, for all my accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4203">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4204" />
                      <span className="font-medium" data-id="element-4205">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4206">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4207" />
                      <span className="font-medium" data-id="element-4208">
                        No, I remember them or write them down
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4209">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4210" />
                      <span className="font-medium" data-id="element-4211">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-4212">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-4213">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep === 2 && <div data-id="element-4214">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-4215">
                Two-factor authentication
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-4216">
                This adds an extra layer of security to your accounts.
              </p>
              <div className="space-y-6 mb-8" data-id="element-4217">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-4218">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-4219">
                    Do you use two-factor authentication (2FA)?
                  </h3>
                  <div className="space-y-3" data-id="element-4220">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4221">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4222" />
                      <span className="font-medium" data-id="element-4223">
                        Yes, for all important accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4224">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4225" />
                      <span className="font-medium" data-id="element-4226">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4227">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4228" />
                      <span className="font-medium" data-id="element-4229">No, I don't use it</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-4230">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-4231" />
                      <span className="font-medium" data-id="element-4232">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between" data-id="element-4233">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-4234">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-4235">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 2 && <div data-id="element-4236">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-4237">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-4238">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-4239">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-4240">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-4241">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}